import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';

export function DeviceStep1Info({ formData, onChange }) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Serial Number <span className="text-red-500">*</span></Label>
        <Input
          value={formData.serial_number}
          onChange={(e) => onChange('serial_number', e.target.value)}
          placeholder="TRK-001"
          className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          data-testid="device-serial-input"
        />
      </div>
      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Module Serial Number</Label>
        <Input
          value={formData.module_sn}
          onChange={(e) => onChange('module_sn', e.target.value)}
          placeholder="MOD-ABC123"
          className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">Device Model</Label>
          <Select value={formData.device_model} onValueChange={(v) => onChange('device_model', v)}>
            <SelectTrigger className="border-slate-300 dark:border-slate-600 dark:bg-slate-700">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="TRK-100">TRK-100 (Basic)</SelectItem>
              <SelectItem value="TRK-200">TRK-200 (Advanced)</SelectItem>
              <SelectItem value="TRK-300">TRK-300 (Enterprise)</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">Firmware Version</Label>
          <Input
            value={formData.firmware_version}
            onChange={(e) => onChange('firmware_version', e.target.value)}
            placeholder="1.0.0"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
        </div>
      </div>
    </div>
  );
}
